import { render, staticRenderFns } from "./batchBind.vue?vue&type=template&id=0c61d7e0&"
import script from "./batchBind.vue?vue&type=script&lang=js&"
export * from "./batchBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports